import * as React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import SideBar from "../components/SideBar";
import "./all.sass";
import useSiteMetadata from "./SiteMetadata";
import { withPrefix } from "gatsby";
import upIcon from '../../static/img/up-icon.png'

const TemplateWrapper = ({ children }) => {
  const { title, description } = useSiteMetadata();
  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>{title}</title>
        <meta name="description" content={description} />

        <link
          rel="favicon.ico"
          sizes="64x64"
          href={`${withPrefix("/")}img/favicon.ico`}
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon.ico`}
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix("/")}img/favicon.ico`}
          sizes="16x16"
        />

        <link
          rel="mask-icon"
          href={`${withPrefix("/")}img/favicon.ico`}
          color="#ff4400"
        />
        <meta name="theme-color" content="#fff" />

        <meta property="og:type" content="business.business" />
        <meta property="og:title" content={title} />
        <meta property="og:url" content="/" />
        <meta
          property="og:image"
          content={`${withPrefix("/")}img/profile.png`}
        />
        <meta name="google-site-verification" content="V7q-9Vb_baxYuGpHdr0z0Aq12OHJhKgOggtiHBfSqsA" />
      </Helmet>
      <Navbar />
      <div className="wrapper" id="inner-content">
        {children}
        <SideBar />
      </div>
      <div id="page-top">
        <a href="#header" title="ページトップへ"><img src={upIcon} alt="上移動" /></a>
      </div>
      <Footer />
    </div>
  );
};

export default TemplateWrapper;
